import React from 'react';
import ProfileLeft from './ProfileLeft';
import ProfileRight from './ProfileRight';

const Profile = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: '80px', fontFamily: 'Poppins' }}>
            <div className="row gy-5">
                <div className="col-lg-5 col-md-6 col-sm-12 col-12">
                    <ProfileLeft />
                </div>
                <div className="col-lg-7 col-md-6 col-sm-12 col-12">
                    <ProfileRight />
                </div>
            </div>
        </div>
    );
};

export default Profile;